<template>
  <v-container style="margin-top: 8vh">
    <v-row dense>
      <v-col cols="auto">
        <div class="progress-bar-container">
          <div class="progress-bar"></div>
        </div>
      </v-col>
    </v-row>

    <v-row dense style="margin-top: 5vh"
      ><v-col cols="12" md="6"></v-col>
      <v-col cols="12" md="6"
        ><h3 class="clipedText primary">Dúvidas frequentes</h3></v-col
      ></v-row
    >

    <v-row no-gutters>
      <v-col
        cols="12"
        md="6"
        class="d-flex align-center justify-center pr-3"
        style="background-color: transparent !important"
      >
        <v-img contain height="50vh" src="@/assets/images/faq/faq.png"></v-img>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="d-flex align-center justify-center slide-right-to-left"
        style="background-color: transparent !important"
      >
        <v-expansion-panels>
          <v-expansion-panel
            v-for="(panel, index) in items"
            :key="index"
            class="mt-2"
            style="border-radius: 10px"
          >
            <v-expansion-panel-header disable-icon-rotate>
              <template v-slot:actions>
                <v-icon> mdi-plus </v-icon>
              </template>
              <span class="text-h6" style="color: #5f5f61; font-weight: bold">{{
                panel.title
              }}</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <span class="inter">{{ panel.text }}</span>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "FaqSection",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      items: [
        {
          title: "Quais são os valores das aulas?",
          text: "Cada professor licenciado possui a liberdade em definir os valores das aulas, você pode se conectar ao professor que tenha uma oferta que caiba no seu bolso.",
        },
        {
          title: "Pago alguma taxa ao mudar de plano?",
          text: "Você tem total liberdade para solicitar alterações nas suas aulas a qualquer momento. Só pedimos que você alinhe diretamente com seu professor com no mínimo 30 dias de antecedência.",
        },

        {
          title: "Quais são os horários das aulas?",
          text: "As aulas possuem horários flexíveis, você pode escolher um professor que tenha disponibilidade semelhante a sua e fazer alterações a partir de alinhamento com ele sem nenhum acréscimo!",
        },
        {
          title: "Preciso pagar pelo material?",
          text: "Não precisa! Ao estudar com um professor licenciado você tem acesso a todo o material didático e demais recursos gratuitamente, você só precisa se preocupar em aprender!",
        },

        {
          title: "Posso acessar as aulas com o celular?",
          text: "Você pode usar o dispositivo que preferir, seja computador, celular ou tablet. Você também pode acessar aos materiais e exercícios a partir do nosso aplicativo Pitch App!",
        },
        {
          title: "Como são realizadas as aulas?",
          text: "As aulas são ao vivo e online, realizadas pelo Google Meet ou pela plataforma que você e seu professor combinarem. Você vai interagir com o seu professor em tempo real, como se estivessem em uma sala de aula presencial!",
        },
        {
          title: "Posso remarcar uma aula?",
          text: "A remarcação das aulas é feita diretamente com o seu professor, alinhe com ele com no mínimo 24h de antecedência para solicitar modificações na sua aula.",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.headerText {
  font-size: 45px;
  white-space: normal;
  font-style: bold;
  overflow: visible;
  padding: 5px;
}

.clipedText {
  background-clip: text;
  color: transparent;
}

.menuLinear {
  width: 97px;
  background-color: linear-gradient(to right, #9923cd, #e8276f);
}

.bolder {
  font-weight: bolder;
}

.secondaryText {
  color: "#5FF5F61" !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  white-space: normal !important;
}

.progress-bar-container {
  width: 92vw;
  height: 1vh;
  background-color: #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #9923cd 0%, #e8276f 75.67%);
  border-radius: 10px 0 0 10px;
  transition: width 1s ease-in-out;
}
</style>
